import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {CommonModule, isPlatformBrowser} from '@angular/common';
import {JWTService} from "../../authentication/jwt.service";
import {WishlistService} from "../../wishlist/wishlist.service";
import {Router} from "@angular/router";
import {ToastMessageService} from "../../services/toast-message.service";

@Component({
	selector: 'fb-product-wishlist-icon',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './product-wishlist-icon.component.html',
	styleUrls: ['./product-wishlist-icon.component.scss']
})
export class ProductWishlistIconComponent implements OnInit {

	@Input()
	public productSku: string = '';

	@Input()
	public productName: string = '';

	public inWishlist: boolean = false;
	public isBrowser: boolean = false;
	public isLoggedIn = false;

	constructor(
		private _jwt: JWTService,
		private _wishlist: WishlistService,
		private _router: Router,
		private _toast: ToastMessageService,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	ngOnInit() {
		this.inWishlist = this._wishlist.isInWishlist(this.productSku);

		this._wishlist.wishlistItems.subscribe(() => {
			this.inWishlist = this._wishlist.isInWishlist(this.productSku);
		});

		this.isLoggedIn = this._jwt.hasValidJWT();
	}

	public storeUrl(): void {
		if (this.isBrowser) {
			localStorage.setItem("storeUrl",window.location.href)
		}

	}


	public toggleWishlist() {
		if(this.isLoggedIn) {
			this._wishlist.toggle(
				this.productName,
				this.productSku,
				true
			);
		}
		else {
			this.storeUrl();
			this._router.navigate(['/auth']).then(() => {
				this._toast.warning('Please Sign In to add to Wishlist', "Please login into your account to add to the wishlist");
			});
		}
	}
}
